export default __webpack_public_path__ + "static/media/case_purple.999ff702.svg";